import { render, staticRenderFns } from "./MessageDisplayer.vue?vue&type=template&id=7b0fa400&scoped=true&"
import script from "./MessageDisplayer.vue?vue&type=script&lang=js&"
export * from "./MessageDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./MessageDisplayer.vue?vue&type=style&index=0&id=7b0fa400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0fa400",
  null
  
)

export default component.exports